// @flow
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import UserSettings from '../UserSettings/UserSettings';
import local from '../../locales/index';

import style from './style';

class User extends Component<Object, {
 selectedUser: string,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      selectedUser: 'self',
    };
  }

  reopen() {
    this.setState({ selectedUser: 'self' });
  }

  render(): React.Node {
    return (<div>
      <Header><span /></Header>
      <div className="container" style={style.container}>
        <Button bsStyle="primary" onClick={() => this.reopen()}>{local.openSettings}</Button>
        <UserSettings userID={this.state.selectedUser} />
      </div>
      <Footer />
    </div>);
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/scenes/User/User.js